module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_tulip-c63c4d8bb9187431e516d9447d9a6338.png";